import BaseService from "./base.service";

const DISABLED_PRESENCE_VALUES = new Set(["false", "0", "no", "off", "disabled"]);

function isPresenceEnabled() {
  const raw = import.meta.env.VITE_ENABLE_USER_PRESENCE ?? import.meta.env.VITE_ENABLE_SCENARIO_PRESENCE;
  if (raw === undefined || raw === null || String(raw).trim() === "") return true;

  return !DISABLED_PRESENCE_VALUES.has(String(raw).trim().toLowerCase());
}

class PresenceService extends BaseService {
  constructor() {
    super("/api/v2/usr/presence");
  }

  async startSession({ currentProjectId = null, currentRoute = null } = {}) {
    if (!isPresenceEnabled()) return null;
    return await this.post("start", { currentProjectId, currentRoute });
  }

  async heartbeat({ sessionId, currentProjectId = null, currentRoute = null }) {
    if (!isPresenceEnabled()) return null;
    if (!sessionId) return null;
    return await this.post("heartbeat", { sessionId, currentProjectId, currentRoute });
  }

  async getActiveScenarioUsers({ projectId, scenarioId } = {}) {
    if (!isPresenceEnabled()) return [];
    if (!projectId || !scenarioId) return [];

    const query = new URLSearchParams({
      projectId: String(projectId),
      scenarioId: String(scenarioId),
    }).toString();

    return await this.get(`active-scenario-users?${query}`);
  }

  async endSession({ sessionId }) {
    if (!isPresenceEnabled()) return null;
    if (!sessionId) return null;
    return await this.post("end", { sessionId });
  }
}

export default new PresenceService();
